var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Thêm mới nhóm học sinh",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-folder-add",
        "panel-icon-tone": "success",
        "panel-title": "Thông tin nhóm",
        "panel-subtitle": "Tạo nhóm học sinh mới",
        "confirm-loading": _vm.loadingButton,
        "confirm-disabled": !_vm.showSaveChange,
        "confirm-text": "Lưu",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSave,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tên nhóm", prop: "groupName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên nhóm" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSave.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.dataForm.groupName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "groupName", $$v)
                  },
                  expression: "dataForm.groupName",
                },
              }),
              _vm.customErrorMessages.newNameKt
                ? _c(
                    "span",
                    { staticClass: "sk-note sk-note--danger sk-u-mt-12" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.customErrorMessages.newNameKt)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "sk-u-mt-12",
              attrs: { label: "Mô tả", prop: "description" },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 1,
                  autosize: "",
                  placeholder: "Nhập mô tả",
                },
                model: {
                  value: _vm.dataForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "description", $$v)
                  },
                  expression: "dataForm.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }